export default "__VITE_PUBLIC_ASSET__16e56c90__"